import http from '@root/utils/axios/admin';

let state = {
    CpusList: [],
    Cpu: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCpusList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/cpus', { params: filter }).then((response) => {
                commit('setCpusList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCpu({ commit }, id) {
        return http.delete('user/cpus/' + id);
    },

    fetchCpu({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/cpus/' + id).then((response) => {
                commit('setCpu', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCpu({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/cpus', data).then((response) => {
                commit('setCpu', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCpuError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCpu({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/cpus/' + data.id, data).then((response) => {
                commit('setCpu', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCpuError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCpusList(state, data) {
        state.CpusList = data;
    },
    setCpu(state, data) {
        state.Cpu.data = data;
    },
    setCpuError(state, error) {

        state.Cpu.error = error.errors;
    },
    cleanCpuError(state, error) {
        state.Cpu.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}